<template>
  <div class="community-link-container">
    <!-- Full page reload for people with ads to reload ads VS faster router-link -->
    <a href="/communities/cofocus" class="nav-link nav--link--mobile" v-if="$isMobile">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        x="0"
        y="0"
        viewBox="0 0 48 48"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class=""
      >
        <g stroke-width="0.1px">
          <path
            d="M43.217 23.783a9.493 9.493 0 0 0-2.944-2 6.492 6.492 0 1 0-8.518-9.711 7.988 7.988 0 0 0-15.51 0 6.492 6.492 0 1 0-8.515 9.712A9.513 9.513 0 0 0 2 30.5V35a5.006 5.006 0 0 0 5 5h7.026A4.977 4.977 0 0 0 18 42h12a4.977 4.977 0 0 0 3.974-2H41a5.006 5.006 0 0 0 5-5v-4.5a9.435 9.435 0 0 0-2.783-6.717ZM36.5 12a4.5 4.5 0 1 1-4.5 4.5 4.505 4.505 0 0 1 4.5-4.5Zm-5.354 10.654a10.983 10.983 0 0 0-2.989-1.832 8.061 8.061 0 0 0 2.257-2.061 6.517 6.517 0 0 0 2.32 3.027 9.59 9.59 0 0 0-1.588.866ZM24 8a6 6 0 1 1-6 6 6.006 6.006 0 0 1 6-6Zm-7.146 14.654a9.59 9.59 0 0 0-1.588-.866 6.517 6.517 0 0 0 2.32-3.027 8.061 8.061 0 0 0 2.257 2.061 10.983 10.983 0 0 0-2.989 1.832ZM7 16.5a4.5 4.5 0 1 1 4.5 4.5A4.505 4.505 0 0 1 7 16.5ZM7 38a3 3 0 0 1-3-3v-4.5a7.489 7.489 0 0 1 11.43-6.379A10.937 10.937 0 0 0 13 31v6a5 5 0 0 0 .1 1Zm26-1a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6a9 9 0 0 1 18 0Zm11-2a3 3 0 0 1-3 3h-6.1a5 5 0 0 0 .1-1v-6a10.937 10.937 0 0 0-2.43-6.879A7.494 7.494 0 0 1 44 30.5Z"
            fill="#222"
            opacity="1"
            data-original="#222"
            class=""
          ></path>
        </g>
      </svg>
    </a>
    <a href="/communities/cofocus" class="nav-link" v-else> Community </a>
    <!-- <a href="/communities/cofocus/posts/630be0a53161020016d6ade4" class="nav-link-indicator" v-show="!clean"></a> -->
    <!-- <a href="/communities/cofocus/posts/62db92ad9460e1001657b917" class="nav-link-indicator" v-show="!clean">🚀 New update! 🥳</a> -->
    <!--     <button @click="$router.push('/communities/cofocus')" class="nav-link">
      Community
    </button> -->
  </div>
</template>

<script>
export default {
  name: "CommunityLink",
  props: {
    clean: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.community-link-container {
  position: relative;
}
.nav-link {
  padding: 12px 14px;
  cursor: pointer;
  display: block;
  font-weight: 600;
  font-size: 16px;
  font-stretch: 1.2;
  color: #222;
}

.nav-link {
  margin-left: 10px;
  margin-left: 30px; /* Until Workspaces link although will be sidebar ribbon */
}

.nav-link:hover {
  color: #888;
}
.nav--link--mobile {
  height: 25px;
  width: 25px;
  padding: 3.5px;
  margin-top: 2px;
  margin-left: 0px;
}
.nav-link-indicator {
  width: 31px;
  height: 16px;
  position: absolute;
  border-radius: 360px;
  right: -10px;
  top: -1px;
  cursor: pointer;
  z-index: 2;
  background-image: linear-gradient(#5aa6ff, #0066ff);
  background-clip: padding-box;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  right: -65px;
  width: 82px;
  right: -75px;
  width: 92px;
  right: -120px;
  width: 130px;

  right: -105px;
  width: 115px;

  height: 10px;
  width: 10px;
  right: 0px;
  top: 3px;

  background-color: #663dff;
  background-image: linear-gradient(319deg, #663dff 0%, #aa00ff 37%, #cc4499 100%);

  background-image: linear-gradient(319deg, #663dff, #7d00ff 37%, #55e5e3);
}
</style>
